import { useDispatch, useSelector } from "react-redux";
import { Fragment } from 'react'
import { Link } from "react-router-dom";
import logoImage from "../../assets/images/logo.png";
import { userLoggedOut } from "../../features/auth/authSlice";
import getAvatar from "gravatar-url";
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Header() {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth) || {};
    const { email } = user || {};

    const logout = () => {
        dispatch(userLoggedOut());
        localStorage.clear();
    };
    return (
        <div
            className="flex"
        >
            <div className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
                <Link to="/projects"><img className="h-12 w-auto" src={logoImage} alt="project-manager" /></Link>
                <input
                    className="flex items-center h-10 px-4 ml-10 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring"
                    type="search"
                    placeholder="Search for anything…"
                />
                <div className="ml-10">
                    <Link
                        className="mx-2 text-sm font-semibold text-indigo-700"
                        to='/projects'
                    >Projects</Link>
                    <Link
                        className="mx-2 text-sm font-semibold text-gray-600 hover:text-indigo-700"
                        to="/teams"
                    >Team</Link
                    >
                </div>
                <div className="ml-10">
                    <Menu as="div" className="relative inline-block text-left">
                        <div>
                            <Menu.Button className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100">
                                <img
                                    className="h-10"
                                    src={getAvatar(email, {
                                        size: 80,
                                    })}
                                    alt={email} />
                                <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
                            </Menu.Button>
                        </div>

                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <div className="py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <span
                                                
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900 cursor-pointer' : 'text-gray-700 cursor-pointer',
                                                    'block px-4 py-2 text-sm'
                                                )}
                                                onClick={logout}
                                            >
                                                Log Out
                                            </span>
                                        )}
                                    </Menu.Item>
                                    {/* <Menu.Item>
                                        {({ active }) => (
                                            <a
                                                href="#"
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'block px-4 py-2 text-sm'
                                                )}
                                            >
                                                Duplicate
                                            </a>
                                        )}
                                    </Menu.Item> */}
                                </div>
                                
                            </Menu.Items>
                        </Transition>
                    </Menu>
                </div>
            </div>


        </div >
    );
}